module.exports = __webpack_public_path__ + "img/cartoonHead1-3.9447fecc.png";